import { ReactComponent as CallBackIcon } from "../assets/Call-Made.svg";

const Newsletter = () => (
  <div
    className="group w-fit flex items-center pt-1 pr-1 pb-1 pl-4 mx-32 max-sm:mr-20 bg-white border-4 border-teal-500 border-solid gap-10 ml-auto max-md:border-2 max-md:gap-5 transition-colors duration-300 hover:bg-teal-500 cursor-pointer"
    onClick={() => window.open("https://openmindagi.substack.com/", "_blank")}
  >
    <h2 className="text-[40px] font-light tracking-tighter text-teal-500 group-hover:text-white max-md:text-[22px] max-sm:text-[18px]">
      Learn what's next
    </h2>
    <CallBackIcon
      alt="Call Made"
      className="w-12 h-12 fill-teal-500 group-hover:fill-white transition-colors duration-300 max-md:w-6 max-md:h-6 max-sm:w-4 max-sm:h-4"
    />
  </div>
);

export default Newsletter;
